// language=GraphQL
export const ALL_WYSIWYG_BLOCKS_QUERY = `query Query {
  wysiwygBlocks: cmsWysiwygBlocks {
    id
    html
  }
}`

// language=GraphQL
export const SINGLE_WYSIWYG_BLOCK_QUERY = `query Query($id: ID!) {
  wysiwygBlock: cmsWysiwygBlock(id: $id) {
    id
    html
  }
}`

// language=GraphQL
export const CREATE_WYSIWYG_BLOCK_MUTATION = `
  mutation Mutation($input: CreateCmsWysiwygBlockInput) {
    wysiwygBlock: createCmsWysiwygBlock(input: $input) {
      id
      html
    }
  }`

// language=GraphQL
export const UPDATE_WYSIWYG_BLOCK_MUTATION = `
  mutation Mutation($input: UpdateCmsWysiwygBlockInput) {
    wysiwygBlock: updateCmsWysiwygBlock(input: $input) {
      id
      html
    }
  }`

// language=GraphQL
export const DELETE_WYSIWYG_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsWysiwygBlockInput) {
    deleteCmsWysiwygBlock(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_WYSIWYG_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsWysiwygBlockInput) {
    forceDeleteCmsWysiwygBlock(input: $input) {
      success
    }
  }`
